import TError from '../templates/error';
import { ILoginDataError } from '../../../shared/types/interfaces/error';
import { routerSelector } from '../../../shared/store/slices/router.slice';
import { useAppSelector } from '../../../shared/store/hooks';

function Error() {
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);

  return (
    <TError
      action={(currentParams as ILoginDataError)?.action}
      message={(currentParams as ILoginDataError)?.message}
    />
  );
}

export default Error;
